module.exports = __webpack_public_path__ + "static/media/play-stone-boss-1-active.6411c1bf.png";